export default "__VITE_ASSET__bad3b8ce__"